import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDrawer, {
    attrs: {
      value: _setup.isDialogOpened,
      title: _setup.t("Фильтры", _setup.options),
      attach: ".vue-the-lpu-filters .v-application",
    },
    on: { input: _setup.handleCloseLpuFilters },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c(_setup.ListItemLpuType, {
              staticClass: "my-2",
              model: {
                value: _setup.lpuFiltersState,
                callback: function ($$v) {
                  _setup.lpuFiltersState = $$v
                },
                expression: "lpuFiltersState",
              },
            }),
            _vm._v(" "),
            _c(_setup.ListItemDoctorSpeciality, {
              staticClass: "my-2",
              model: {
                value: _setup.lpuFiltersState,
                callback: function ($$v) {
                  _setup.lpuFiltersState = $$v
                },
                expression: "lpuFiltersState",
              },
            }),
            _vm._v(" "),
            _c(_setup.ListItemPlace, {
              staticClass: "my-2",
              model: {
                value: _setup.lpuFiltersState,
                callback: function ($$v) {
                  _setup.lpuFiltersState = $$v
                },
                expression: "lpuFiltersState",
              },
            }),
            _vm._v(" "),
            _c(_setup.ListItemTimeWork, {
              staticClass: "my-2",
              model: {
                value: _setup.lpuFiltersState,
                callback: function ($$v) {
                  _setup.lpuFiltersState = $$v
                },
                expression: "lpuFiltersState",
              },
            }),
            _vm._v(" "),
            _c(_setup.SwitchHighRating, {
              staticClass: "mb-2",
              model: {
                value: _setup.lpuFiltersState,
                callback: function ($$v) {
                  _setup.lpuFiltersState = $$v
                },
                expression: "lpuFiltersState",
              },
            }),
            _vm._v(" "),
            _c(_setup.SwitchAppointment, {
              staticClass: "mb-2",
              model: {
                value: _setup.lpuFiltersState,
                callback: function ($$v) {
                  _setup.lpuFiltersState = $$v
                },
                expression: "lpuFiltersState",
              },
            }),
            _vm._v(" "),
            !_setup.isYDoc
              ? _c(_setup.SwitchClub, {
                  model: {
                    value: _setup.lpuFiltersState,
                    callback: function ($$v) {
                      _setup.lpuFiltersState = $$v
                    },
                    expression: "lpuFiltersState",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(VDivider, { staticClass: "my-4" }),
            _vm._v(" "),
            _c(_setup.ListItemLpuSort, {
              model: {
                value: _setup.lpuFiltersState,
                callback: function ($$v) {
                  _setup.lpuFiltersState = $$v
                },
                expression: "lpuFiltersState",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(_setup.BtnApplyFilters, {
              staticClass: "pa-2 elevation-8",
              attrs: {
                active: _setup.isDialogOpened,
                "trigger-request": _setup.triggerUpdateLpuCount,
              },
              on: {
                "click:submit": _setup.applyLpuFilters,
                "click:close": _setup.handleCloseLpuFilters,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }